import { Outlet, Navigate } from 'react-router-dom'

import useAuth from '../hooks/useAuth'

const PrivateRoute = () => {
  const { loading, userRegister } = useAuth()

  if (!loading) {
    return
  }

  return (
    <>
      { userRegister
        ? (
          <Outlet />
        )
        : (
          <Navigate to="/" />
        )}
    </>
  )
}

export default PrivateRoute
